<template>
  <span>
    <v-tooltip v-if="user.scrutineer" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="dialog = true" icon>
          <v-icon
            @click="getPollSummary()"
            color="primary"
            v-bind="attrs"
            v-on="on"
            >mdi-text-box-search-outline</v-icon
          >
        </v-btn>
      </template>
      <span>You are a voting scrutineer</span>
    </v-tooltip>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dense flat dark color="primary">
          <span>
            <v-icon>mdi-text-box-search-outline</v-icon>
          </span>
          <v-spacer></v-spacer>
          <div class="text-center white--text"><VoteStatus /></div>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="activePoll">
            <v-card-title style="word-break: normal;">
              {{ activePoll.pollText }}
            </v-card-title>
            <v-card-text>
              <div class="text-center">
                <span v-if="!activePoll.active">(CLOSED) </span>Poll results for
                scrutineers
              </div>

              <VoteResults />
            </v-card-text>
          </div>

          <v-card-title v-else class="justify-center"
            >No results. Wating for poll.</v-card-title
          >
        </v-card-text>
        <v-divider></v-divider>

        <v-card-text>
          <v-list-item three-line v-for="poll in polls" :key="poll._id">
            <v-list-item-content>
              <v-list-item-title>{{ poll.pollText }}</v-list-item-title>
              <v-list-item-subtitle>
                <span>{{ formatSummary(poll) }}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span>{{ formatRuntime(poll) }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import client from "@/services/axios";
import VoteResults from "@/components/Results/VoteResults.vue";
import VoteStatus from "@/components/ToolBar/VoteStatus.vue";
import { mapState } from "vuex";
export default {
  components: {
    VoteResults,
    VoteStatus
  },
  data() {
    return {
      dialog: false,
      polls: []
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      activePoll: (state) => state.activePoll,
      proxies: (state) => state.proxies,
      event: (state) => state.events.event
    })
  },
  methods: {
    async getPollSummary() {
      const result = await client.get(
        "polls/event/" + this.$store.state.event._id
      );
      this.polls = result.data.filter(
        (item) => item.totalVotes > 0 && !item.active
      );
    },
    formatSummary(poll) {
      const percentage = Math.round(
        (poll.onlineVoted / poll.onlineCount) * 100
      );

      return `${poll.onlineVoted} of ${poll.onlineCount} (${percentage}%) voted / online ballots: ${poll.totalVotes}`;
    },
    formatRuntime(poll) {
      let fromTime = new Date(poll.started);
      let toTime = new Date(poll.ended);
      let differenceTravel = toTime.getTime() - fromTime.getTime();
      let seconds = Math.floor(differenceTravel / 1000);
      let minutes = this.displayTime(seconds);

      return `Runtime: ${minutes}`;
    },
    displayTime(seconds) {
      const format = (val) => `0${Math.floor(val)}`.slice(-2);
      const hours = seconds / 3600;
      const minutes = (seconds % 3600) / 60;

      return [hours, minutes, seconds % 60].map(format).join(":");
    }
  }
};
</script>
